import React from 'react';
import Watch from "./components/WatchApi/Watch";
import jungjinJcoupimg from './components/img/coup/JungjinJcoupView.png'

function MainPage() {

    return (
        <div>
            <div>
                <img className='mx-auto d-block' style={{width:'60%', marginTop:'10%'}} src={jungjinJcoupimg} alt='' />
            </div>
            <div>            
                <Watch />
            </div>
        </div>             
    );
}

export default MainPage;